import InputAdornment from '@mui/material/InputAdornment';
import { type Components, type Theme } from '@mui/material/styles';
import TextField, { type TextFieldProps } from '@mui/material/TextField';
import useMediaQuery from '@mui/material/useMediaQuery';
import { DEFAULT_DESKTOP_MODE_MEDIA_QUERY } from '@mui/x-date-pickers/internals';

import Calendar from '../icons/Calendar.svg';

/**
 * Поле даты: на десктопе иконку календаря кладёт сам пикер,
 * на сенсорной ширине пикер мобильный и иконки нет — добавляем ту же, тап по полю открывает модалку
 * @param props Пропсы текстового поля пикера
 */
const DatePickerTextField = (props: TextFieldProps) => {
  const isDesktop = useMediaQuery(DEFAULT_DESKTOP_MODE_MEDIA_QUERY, {
    defaultMatches: true
  });
  const { InputProps, ...rest } = props;

  // Иконка календаря — в 14px от правого края поля, как иконки других полей (карандаш, замок):
  // на десктопе кнопка пикера с edge='end' сдвинута MUI на −12px; −5px ставит иконку (24px в кнопке с padding 8px) на те же 14px
  if (isDesktop) {
    return (
      <TextField
        {...props}
        sx={{
          ...props.sx,
          '& .MuiInputAdornment-root .MuiIconButton-edgeEnd': { mr: '-5px' }
        }}
      />
    );
  }

  return (
    <TextField
      {...rest}
      sx={{
        ...rest.sx,
        '& input::placeholder': { fontSize: 14 }
      }}
      InputProps={{
        ...InputProps,
        endAdornment: (
          <InputAdornment position='end' sx={{ ml: 0 }}>
            <Calendar aria-hidden='true' />
          </InputAdornment>
        )
      }}
    />
  );
};

const MuiDatePicker: Components<Theme>['MuiDatePicker'] = {
  defaultProps: {
    slots: {
      textField: DatePickerTextField,
      /**
       * Кстомная иконка
       * @param root0 Пропсы
       * @param root0.ownerState Проп для исключения
       */
      openPickerIcon: ({ ownerState: _, ...restProps }) => {
        return <Calendar {...restProps} />;
      }
    }
  }
};

const MuiDateCalendar: Components<Theme>['MuiDateCalendar'] = {
  styleOverrides: {
    /**
     * Корневые стили кнопки
     * @param root0 Корневые пропсы
     * @param root0.theme Тема
     */
    root: ({ theme }) => ({
      boxShadow: theme.shadows[8]
    })
  }
};

export const datePickers = { MuiDatePicker, MuiDateCalendar };
